import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
  },
  mutations: {
    start(state) {
      state.loading = true
    },
    end(state) {
        state.loading = false
    }
  },
  actions: {
  },
  modules: {
  }
})
